import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconTelephone(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={76.96}
          y1={82.66}
          x2={17.92}
          y2={23.62}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M35.08,19.32a2,2,0,0,1,1,.26,3,3,0,0,1,1.25,1.27L43,34.35a2.43,2.43,0,0,1,.12,1.59,2.59,2.59,0,0,1-.83,1.36l-6.76,5.51-.93.76.53,1.07A46.36,46.36,0,0,0,55.94,65.42L57,66l.76-.93,5.5-6.77a2.62,2.62,0,0,1,1.37-.83,2.47,2.47,0,0,1,.6-.08,2.6,2.6,0,0,1,1,.19L79.73,63.3A2.92,2.92,0,0,1,81,64.56a1.9,1.9,0,0,1,.18,1.51v.06L78.29,78.77a2.81,2.81,0,0,1-1,1.37,2.23,2.23,0,0,1-1.5.54,55,55,0,0,1-28.15-7.59A55.44,55.44,0,0,1,27.61,53a55.34,55.34,0,0,1-7.71-28.4,2.06,2.06,0,0,1,.54-1.37,2.85,2.85,0,0,1,1.37-1l12.64-2.87h.06a2.3,2.3,0,0,1,.57-.08m0-1.5a3.52,3.52,0,0,0-1,.13l-12.7,2.89a4.44,4.44,0,0,0-2.14,1.45,3.6,3.6,0,0,0-.88,2.33,56.48,56.48,0,0,0,7.92,29.16A56.73,56.73,0,0,0,46.93,74.39a56.33,56.33,0,0,0,28.91,7.79,3.78,3.78,0,0,0,2.45-.88,4.37,4.37,0,0,0,1.45-2.14l2.89-12.69a3.39,3.39,0,0,0-.32-2.64,4.37,4.37,0,0,0-1.94-1.89L66.79,56.16a4.23,4.23,0,0,0-1.54-.31,4,4,0,0,0-1,.12,4.13,4.13,0,0,0-2.14,1.32l-5.53,6.79A44.88,44.88,0,0,1,36.5,44l6.79-5.53a4.09,4.09,0,0,0,1.32-2.14,4,4,0,0,0-.19-2.51L38.64,20.21a4.51,4.51,0,0,0-1.88-1.94,3.47,3.47,0,0,0-1.68-.45Z"
      />
    </svg>
  );
}
export default SvgEchIconTelephone;
